export default "__VITE_ASSET__OF6pC8WJ__"